'use client';

import { STUDIO_AI_NAME } from '@/@studio-ai/constants';
import { PersistentAssistantButtonProps } from '@/@studio-ai/persistent-assistant/props';
import { Tooltip } from '@heroui/react';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import { PERSISTENT_ASSISTANT_CONFIG } from '../constants';
import { useModalOverlayOpen } from '../hooks/use-modal-overlay-open';

export function PersistentAssistantButton({
    onClick,
    position = 'bottom',
}: PersistentAssistantButtonProps) {
    const isRightPosition = position === 'right';
    const isModalOpen = useModalOverlayOpen();

    return (
        <div
            className={`pointer-events-none fixed flex ${
                isRightPosition
                    ? 'inset-y-0 right-0 items-center'
                    : 'inset-x-0 bottom-0 justify-center'
            }`}
            style={{
                zIndex: isModalOpen
                    ? PERSISTENT_ASSISTANT_CONFIG.Z_INDEX_UNDER_MODAL
                    : PERSISTENT_ASSISTANT_CONFIG.Z_INDEX,
            }}
        >
            <Tooltip
                content={`Open ${STUDIO_AI_NAME}`}
                placement={isRightPosition ? 'left' : 'top'}
                size="sm"
                delay={300}
            >
                <motion.button
                    onClick={onClick}
                    className={`pointer-events-auto flex items-center justify-center gap-1 bg-mfour-green text-white shadow-md shadow-mfour-green/20 transition-shadow hover:shadow-lg hover:shadow-mfour-green/30 ${
                        isRightPosition
                            ? 'h-10 w-10 flex-row rounded-l-lg'
                            : 'h-10 w-10 flex-col rounded-t-lg'
                    }`}
                    aria-label={`Open ${STUDIO_AI_NAME} assistant`}
                    whileHover={isRightPosition ? { x: -3 } : { y: -3 }}
                    whileTap={{ scale: 0.97 }}
                    initial={isRightPosition ? { opacity: 0, x: 30 } : { opacity: 0, y: 30 }}
                    animate={isRightPosition ? { opacity: 1, x: 0 } : { opacity: 1, y: 0 }}
                    exit={isRightPosition ? { opacity: 0, x: 30 } : { opacity: 0, y: 30 }}
                    transition={{ duration: 0.2 }}
                >
                    <Icon
                        icon={isRightPosition ? 'lucide:chevron-left' : 'lucide:chevron-up'}
                        width={14}
                        height={14}
                        className="shrink-0 opacity-70"
                    />
                    <Icon icon="lucide:bot" width={16} height={16} className="shrink-0" />
                </motion.button>
            </Tooltip>
        </div>
    );
}
